import { render, staticRenderFns } from "./create_person_list.vue?vue&type=template&id=b2512868&scoped=true&"
import script from "./create_person_list.vue?vue&type=script&lang=js&"
export * from "./create_person_list.vue?vue&type=script&lang=js&"
import style0 from "./create_person_list.vue?vue&type=style&index=0&id=b2512868&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2512868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2512868')) {
      api.createRecord('b2512868', component.options)
    } else {
      api.reload('b2512868', component.options)
    }
    module.hot.accept("./create_person_list.vue?vue&type=template&id=b2512868&scoped=true&", function () {
      api.rerender('b2512868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity/components/create_person_list.vue"
export default component.exports